import { Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output } from '@angular/core';
import { Store } from '@ngrx/store';
import { Subscription } from 'rxjs';
import { setRapidoMode } from 'search/actions/search.actions';
import { State } from 'search/reducers/root.reducer';
import { FeatureToggleService } from '../../../services/feature-toggle.service';
import { UpdateSearchObjectAction } from 'search/actions/facet.actions';
import { defaultSearchObjectConfig, SearchObject } from 'search/models/search-object';

const MAIN_PAGE_REGEXP = '(/search$)|(/search\\?.*query*)|(^\/?(\\?.+|#.+)?$)';

@Component({
  selector: 'app-global-header',
  templateUrl: './global-header.component.html',
  styleUrls: ['./global-header.component.scss'],
})
export class GlobalHeaderComponent implements OnInit, OnChanges, OnDestroy {
  @Input() public url: string;
  @Input() public title: string;
  @Input() public logo: string;
  @Output() public skipTo = new EventEmitter();
  @Output() public onResetFacets = new EventEmitter();

  public isMainPage = true;
  public logoSrc: string;
  public isLogoLoaded = true;
  public isLogoError = false;

  private readonly subscriptions: Subscription = new Subscription();
  public isCentralRequestInterface = false;

  constructor(
    private readonly store: Store<State>,
    private readonly featureToggleService: FeatureToggleService
  ) {

  }

  public ngOnInit() {
    this.logoSrc = this.logo ? `${this.logo}?timestamp=${Date.now()}` : ''; // solution to bypass browser cache
    this.isMainPage = !!this.url.match(MAIN_PAGE_REGEXP);
    this.isLogoLoaded = !this.logoSrc;
    this.isCentralRequestInterface = this.featureToggleService.getToggles()['licenseCentralRequest'];
  }

  public ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }

  public ngOnChanges() {
    this.isMainPage = !!this.url.match(MAIN_PAGE_REGEXP);
  }

  public resetFacets(event: Event) {
    if (!this.isCentralRequestInterface) {
      this.store.dispatch(setRapidoMode({rapidoMode: false}));
    }
    const cleanSearchObject: Partial<SearchObject> = { ...defaultSearchObjectConfig, rapido: undefined };
    this.store.dispatch(new UpdateSearchObjectAction(cleanSearchObject));
    event.preventDefault();
    event.stopPropagation();
    this.onResetFacets.emit();
  }

  public skipToElement(event: Event, elementName: string) {
    event.preventDefault();
    this.skipTo.emit(elementName);
  }

  public onImgLoad() {
    this.isLogoLoaded = true;
  }

  public onImgError() {
    this.isLogoError = true;
    this.isLogoLoaded = true;
  }
}
